import { Localized } from 'dg-web-shared/lib/Localization.tsx';
import { Typography } from '@mui/material';
import { FeedbackPopup } from '../../components/FeedbackPopup.tsx';
import {
    useNavigateOnSuccess,
    useServerWrite,
} from 'dg-web-shared/lib/hooks/ServerStateHooks.ts';
import { useNavigate } from 'react-router';
import { useParamOrNull } from 'dg-web-shared/lib/ReactRouterHelpers.ts';

export function EmailNeedsConfirmationRoute() {
    const emailEncoded = useParamOrNull('email');
    const email = emailEncoded ? decodeURIComponent(emailEncoded) : null;
    const navigate = useNavigate();
    const [anotherLinkState, requestAnotherLink] = useServerWrite<
        { email: string | null },
        never
    >(() => ({
        url: '/ui-api/parkingabo/resend-verification-link',
    }));

    useNavigateOnSuccess(anotherLinkState, '/email-sent');

    return (
        <FeedbackPopup
            open={true}
            onConfirm={() => requestAnotherLink({ email: email })}
            onAbort={() => navigate('/login')}
            title={
                <Localized
                    de="E-Mail nicht bestätigt"
                    fr="E-mail pas confirmée"
                    it="E-mail non confermato"
                    en="Email not confirmed"
                />
            }
            confirmLabel={
                <Localized
                    de="Link senden"
                    fr="Envoyer le lien"
                    it="Invia link"
                    en="Send link"
                />
            }
            abortLabel={
                <Localized de="Zurück" fr="Retourner" it="Indietro" en="Back" />
            }
        >
            <Typography sx={{ fontSize: 14 }}>
                <Localized
                    de="Sie müssen Ihre E-Mail-Adresse verifizieren, bevor Sie sich anmelden können."
                    fr="Vous devez vérifier votre adresse e-mail avant de pouvoir vous connecter."
                    it="Prima di poter accedere deve verificare il suo indirizzo e-mail."
                    en="You must verify your e-mail address before you can log in."
                />
            </Typography>
        </FeedbackPopup>
    );
}
